// extracted by css-extract-rspack-plugin
export default {"root":"Cw5uso"};